import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Button from 'component/button.component';
import logo from 'resource/img/logo.png';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import OpacityModal from 'component/opacity.modal.component';
import LoginModal from './login.modal.component';
import NewsletterModal from 'component/newsletter.modal.component';
import history from 'config/history';

const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    overflowX: 'hidden',
    maxWidth: '100vw',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  drawer: {
    background: 'black',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    background: 'black',
    textAlign: 'center',
    maxWidth: '100%',
    left: 0,
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  closeMenuButton: {
    marginRight: 'auto',
    marginLeft: 0,
  },
}));
export default function ResponsiveDrawer({
  isUserLoggedIn,
  user,
  userLogin,
  resetPassword,
  subscribeNewsletter,
}) {
  let links = isUserLoggedIn
    ? [
        { to: '/', text: 'Home' },
        { to: '/proposito', text: 'Propósito' },
        { to: '/contato', text: 'Contato' },
        { to: '/acompanhar-agenda', text: 'Acompanhar Agenda' },
        { to: '/novo-recorte', text: 'Novo Recorte' },
        { to: '/sobre-recorte', text: 'Sobre o Recorte' },
      ]
    : [
        { to: '/', text: 'Home' },
        { to: '/proposito', text: 'Propósito' },
        { to: '/contato', text: 'Contato' },
        { to: '/sobre-recorte', text: 'Sobre o Recorte' },
      ];
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loginModal, setLoginModal] = React.useState(null);

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  function openLogin() {
    handleDrawerToggle();
    if (loginModal) {
      loginModal._show();
    }
  }

  function openPerfil() {
    handleDrawerToggle();
    history.push('/perfil');
  }

  const drawer = (
    <div className="flex-column justify-between h-100">
      <List>
        {links.map((obj, index) => (
          <Link to={obj.to} key={index} onClick={handleDrawerToggle}>
            <ListItem button>
              <ListItemText primary={obj.text} />
            </ListItem>
          </Link>
        ))}
      </List>
      <List>
        <ListItem button>
          <NewsletterModal
            onOkBtn={subscribeNewsletter}
            user={user}
            customStyle={{ color: 'black' }}
          />
        </ListItem>
        {isUserLoggedIn ? (
          <ListItem
            button
            onClick={openPerfil}
            className="flex-row align-center justify-center"
          >
            {!user.image ? (
              <span
                className="flex-row align-center justify-center"
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 50,
                  backgroundColor: '#AAAAAA',
                  fontWeight: 'bold',
                }}
              >
                {user.name.substr(0, 1).toUpperCase()}
              </span>
            ) : (
              <img
                src={user.image}
                alt="Imagem do usuário"
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 50,
                  backgroundColor: 'transparent',
                }}
              />
            )}
            <div
              className="flex-row align-end justify-center"
              style={{ marginLeft: 10 }}
            >
              <span
                style={{
                  color: '#AAAAAA',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
              >
                {user.name}
              </span>
            </div>
          </ListItem>
        ) : (
          <>
            <Link to="/acesso" onClick={handleDrawerToggle}>
              <ListItem button className="bg-primary">
                <ListItemText primary="Entrar" />
              </ListItem>
            </Link>
          </>
        )}
      </List>
    </div>
  );
  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <CssBaseline />
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Link
            to="/"
            className="flex-row justify-between align-center"
            style={{ width: '140px' }}
          >
            <img
              style={{ width: '40px', height: '38px' }}
              src={logo}
              alt="logo"
            />
            <Typography variant="h6" noWrap>
              Juslabore
            </Typography>
          </Link>
        </Toolbar>
      </AppBar>

      <nav className={classes.drawer}>
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <IconButton
            onClick={handleDrawerToggle}
            className={classes.closeMenuButton}
          >
            <CloseIcon />
          </IconButton>
          {drawer}
        </Drawer>
      </nav>
      <OpacityModal modalRef={ref => setLoginModal(ref)}>
        <LoginModal
          userLogin={userLogin}
          resetPassword={resetPassword}
          modalRef={loginModal}
        />
      </OpacityModal>
    </div>
  );
}
